import ErrorStyles from "./Error.module.scss";
import ErrorOrbitLogoSVG from "../../assets/images/ErrorOrbitLogo.svg";
import Typography from "../Typography/Typography";
import { ErrorConfig, ErrorType } from "../../common/constants";

const Error = ({ type }: any) => {
  const path = window.location.pathname;
  const errorData = ErrorConfig?.[type];
  const errorString = `${errorData?.errorText?.prefix} ${
    type === ErrorType.NOT_FOUND ? path : ""
  } ${errorData?.errorText?.suffix}`;
  return (
    <div className={ErrorStyles.wrapper}>
      <div className={ErrorStyles.content}>
        <div className={ErrorStyles.left}>
          {/* <img className={ErrorStyles.logo} src={ErrorOrbitLogoSVG} alt="" /> */}
          <div>
            <div className={ErrorStyles.ecode}>
              <Typography style={{ fontWeight: "700", fontSize: "20px" }}>
                {errorData?.errorCode}.
              </Typography>
              <Typography
                style={{
                  fontSize: "20px",
                  fontWeight: "400",
                  color: "#595D72",
                }}
              >
                {errorData?.errorTitle}
              </Typography>
            </div>

            <div className={ErrorStyles.estring}>
              <Typography style={{ fontSize: "18px", color: "#595D72" }}>
                {errorString}
              </Typography>
            </div>
          </div>
        </div>
        <img
          src={errorData?.errorImg}
          className={ErrorStyles.errorImage}
          alt=""
        />
      </div>
    </div>
  );
};

export default Error;
